const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

const small = SizesUtils.winWidth() < 768 || SizesUtils.winHeight() < 768;
export const initialImagesManifest = small ? './data/include/imagesPart0_mobile.json' : './data/include/imagesPart0.json';
export const secondaryImagesManifest = './data/include/imagesPart1.json';

export const initialDataManifest = './data/include/dataManifest.json';
// export const secondaryDataManifest = './data/include/test.json';

export const geometriesManifest = './data/include/geometrySettings.json';
export const initialStories = [
    //
    'event-0',
    'event-1',
    'event-2',
    'event-3',
    'event-4',
    'event-5',
    'event-6',
    'event-7',
    'event-8',
    'event-9',
    'event-10',
    'event-11'
];

export const maxTexturesType = 16;
export const textureURLBase = 'http://dyn.ig.rambler.ru/_/';
export const textureURLBaseLoc = small ? './img/include/textures/mobile/' : './img/include/textures/';
